// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"571":"9e7fe445","594":"e4bf1bc6"}[chunkId] + ".chunk.js";
};